import { render } from "./specialAuthText.vue?vue&type=template&id=369aa58e&ts=true"
import script from "./specialAuthText.vue?vue&type=script&lang=ts"
export * from "./specialAuthText.vue?vue&type=script&lang=ts"

import "./specialAuthText.vue?vue&type=style&index=0&id=369aa58e&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__